import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";

@Component({
	selector: "app-record-control-footer",
	templateUrl: "./record-control-footer.component.html",
	styleUrls: ["../../../modules/commandCenter/commandcenter.scss"],
})
export class RecordControlFooterComponent implements OnInit {
	@Input() hideSave: boolean = false;
	@Input() hideDelete: boolean = false;
	@Input() hideCancel: boolean = false;
	@Input() hideAdd: boolean = true;
	@Input() cancelLabel: string = "Close";
	@Input() saveLabel: string = "Save";
	@Input() deleteLabel: string = "Delete";
	@Input() addLabel: string = "Add";
	@Input() saveDisabled: boolean = false;
	@Input() addDisabled: boolean = false;
	@Input() onSave;
	@Output() onSaveChange = new EventEmitter<any>();
	@Input() cancelDisabled: boolean = false;
	@Input() onCancel;
	@Output() onCancelChange = new EventEmitter<any>();
	@Input() deleteDisabled: boolean = false;
	@Input() onDelete;
	@Output() onDeleteChange = new EventEmitter<any>();
	@Input() deletePromptOverride: boolean = false;
	@Input() onAdd: any;
	@Output() onAddChange = new EventEmitter<any>();

	constructor(public app: AppService) {}

	ngOnInit(): void {}

	deleteConfirmation() {
		if (!this.deletePromptOverride) {
			this.app.confirmation.confirm({
				message: `Delete?`,
				accept: async () => {
					this.onDeleteChange.emit();
				},
				reject: async () => {
					this.app.confirmation.close();
				},
			});
		} else {
			this.onDeleteChange.emit();
		}
	}
}
